/**
 * Format an online/last-seen state into a human-readable string.
 *  - online → "Online now"
 *  - last_seen within 60s → "Active just now"
 *  - same day → "Active 12 min ago" or "Active 3h ago"
 *  - earlier today/yesterday → "Last seen at 10:24 AM" / "Last seen yesterday at 9:00 PM"
 *  - older → "Last seen on 12 May"
 *  - if show_last_seen=false → "Last seen recently"
 */
export function formatPresence({ is_online, last_seen, show_last_seen = true } = {}) {
  if (is_online) return 'Online now';
  if (!show_last_seen) return 'Last seen recently';
  if (!last_seen) return '';

  const ts = new Date(last_seen);
  if (isNaN(ts.getTime())) return '';

  const now = new Date();
  const diffMs = now - ts;
  const diffSec = Math.floor(diffMs / 1000);
  const diffMin = Math.floor(diffSec / 60);
  const diffHr = Math.floor(diffMin / 60);

  if (diffSec < 60) return 'Active just now';
  if (diffMin < 60) return `Active ${diffMin} min ago`;
  if (diffHr < 6) return `Active ${diffHr}h ago`;

  const sameDay = ts.toDateString() === now.toDateString();
  const yest = new Date(now); yest.setDate(now.getDate() - 1);
  const isYesterday = ts.toDateString() === yest.toDateString();
  const time = ts.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });

  if (sameDay) return `Last seen at ${time}`;
  if (isYesterday) return `Last seen yesterday at ${time}`;

  const date = ts.toLocaleDateString([], { month: 'short', day: 'numeric' });
  return `Last seen on ${date}`;
}
